import { createAction } from "utils/context";
import * as constants from "./constants";

export const PROPSOCH_ACTIONS = {
  // login: createAsyncActions(constants.LOGIN),
  roles: createAction(constants.ROLES),
  users: createAction(constants.USERS),
  locations: createAction(constants.LOCATIONS),
  userRole: createAction(constants.USER_ROLE),
};
